<template>
    <section class="content">
        <div class="row">
            <div class="col-md-12">
                <places-form :place="place" :disabled="disabled" @activate-mod="activateMod()"
                              @click="updatePlace()"
                              :showLabels="true"></places-form>
            </div>
        </div>
    </section>
</template>

<script>
  import types from '../../store/mutation-types'
  import placesApi from '../../api/places'
  import placesForm from './Form.vue'

  export default {

    components: {
      placesForm
    },

    data () {
      return {
        place: false,
        disabled: true,
        interval: null
      }
    },

    beforeCreate () {
      placesApi.show(this.$route.params.id)
        .then((response) => {
          this.place = response
        })
    },

    created () {
      this.$store.commit(types.SET_HEADER_STATE, {
        pageTitle: 'Luoghi inseriti',
        createButton: {
          display: true,
          text: 'Nuovo luogo',
          to: '/place'
        }
      })
      this.interval = setInterval(() => {
        if (!this.disabled) {
          placesApi.update(this.$route.params.id, this.place)
        }
      }, process.env.AUTOSAVE_TIMEOUT)
    },

    beforeDestroy () {
      clearInterval(this.interval)
    },

    methods: {
      activateMod () {
        this.disabled = !this.disabled
      },
      updatePlace () {
        this.loader = true
        return placesApi.update(this.$route.params.id, this.place)
          .then((response) => {
            toastr.success('Il luogo è stato salvato correttamente')
            this.loader = false
            this.disabled = true
          })
          .catch((response) => {
            this.loader = false
          })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/places/Show.vue